export default __webpack_public_path__ + "static/before-after-snap-bd97be18c79d5b3805ce93da4f100ae7.gif";